import marquee from 'vanilla-marquee/dist/vanilla-marquee.js';

/*let speedMarque = 20;

if (document.getElementById('marquee_1')) {
  if (window.innerWidth <= 640) {
    speedMarque = 10;
  }
  new marquee(document.getElementById('marquee_1'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    recalcResize: false,
    startVisible: true,
  });
}

if (document.getElementById('marquee_2')) {
  new marquee(document.getElementById('marquee_2'), {
    duplicated: true,
    gap: 12,
    speed: speedMarque,
    pauseOnHover: true,
    direction: 'right',
    recalcResize: false,
    startVisible: true,
  });
}*/

// if (document.querySelector('.our-community__marquee')) {
//   const marqueeArray = [];

//   const marqueeArr = document.querySelectorAll('.our-community__marquee');

//   marqueeArr.forEach((marqueeEl, i) => {
//     const itemsArr = marqueeEl.querySelectorAll('.our-community__logo');

//     const cloneItems = (items, times) => {
//       for (let i = 0; i < times; i++) {
//         items.forEach((itemEl) => {
//           const clone = itemEl.cloneNode(true);
//           marqueeEl.appendChild(clone);
//         });
//       }
//     }
//     cloneItems(itemsArr, 6);
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });
//     // itemsArr.forEach((itemEl) => {
//     //   const clone = itemEl.cloneNode(true);
//     //   marqueeEl.appendChild(clone);
//     // });


//     const container = 1440;

//     const finalItemsArr = marqueeEl.querySelectorAll('.our-community__logo');

//     let duration = 5000;

//     const totalWidth = finalItemsArr.length * (finalItemsArr[0].clientWidth + 12);
//     let baseSpeed = 20;

//     if (window.innerWidth < 550) {
//       baseSpeed = 2;
//     }

//     const scalingFactor = window.innerWidth < 768 ? 2.5 : 1;
//     baseSpeed *= scalingFactor;

//     duration = (totalWidth / window.innerWidth) * baseSpeed;

//     let direction = 'up';
//     let pauseOnHover = false;

//     if (window.innerWidth <= 1024) {
//       pauseOnHover = false;
//     }

//     direction = 'left';

//     if (i % 2) {
//       direction = 'right';
//     }

//     const mq = new marquee(marqueeEl, {
//       delayBeforeStart: 0,
//       direction: direction,
//       pauseOnHover: pauseOnHover,
//       duplicated: false,
//       recalcResize: true,
//       startVisible: true,
//       gap: 26,
//       duration: duration * 1000,
//     });

//     marqueeArray.push(mq);

//     /*if (window.innerWidth <= 1024) {
//       setTimeout(function () {
//         const itemsArr = marqueeEl.querySelectorAll('.our-community__logo');
//         itemsArr.forEach((item) => {
//           item.addEventListener('click', (e) => {
//             if (item.classList.contains('is-hover')) {
//               item.classList.remove('is-hover');
//               mq.resume();
//             } else {
//               const newArr = document.querySelectorAll('.our-community__logo');
//               for (let j = 0; j < newArr.length; j++) {
//                 newArr[j].classList.remove('is-hover');
//               }
//               item.classList.add('is-hover');
//               for (let j = 0; j < marqueeArray.length; j++) {
//                 marqueeArray[j].resume();
//               }
//               mq.pause();
//             }
//           });
//         });
//       }, 100);
//     }*/
//   });

//   /*document.addEventListener('click', function (event) {
//     if (!marqueeArr[0].parentElement.contains(event.target)) {
//       const newArr = document.querySelectorAll('.our-community__logo');
//       for (let j = 0; j < newArr.length; j++) {
//         newArr[j].classList.remove('is-hover');
//       }
//       for (let j = 0; j < marqueeArray.length; j++) {
//         marqueeArray[j].resume();
//       }
//     }
//   });*/
// }




const marqueeInstances = new Map();

function initResponsiveMarquee({
  containerSelector,
  itemSelector,
  cloneTimes = 4,
  breakpoint = '(max-width: 1023px)',
  getOptions = (el, i) => ({})
}) {
  const media = window.matchMedia(breakpoint);

  console.log('start marq');

  const init = () => {
    console.log('init marquee');
    
    const elements = document.querySelectorAll(containerSelector);

    console.log(elements);
    
    elements.forEach((el, i) => {
      if (el.dataset.marqueeInit === 'true') return;

      const originals = el.querySelectorAll(itemSelector);
      for (let t = 0; t < cloneTimes; t++) {
        originals.forEach((item) => {
          const clone = item.cloneNode(true);
          el.appendChild(clone);
        });
      }

      const allItems = el.querySelectorAll(itemSelector);
      const totalWidth = allItems.length * (allItems[0]?.clientWidth + 12);
      let baseSpeed = window.innerWidth < 550 ? 2 : 20;
      const scalingFactor = window.innerWidth < 768 ? 2.5 : 1;
      baseSpeed *= scalingFactor;
      const duration = (totalWidth / window.innerWidth) * baseSpeed;

      const direction = i % 2 === 0 ? 'left' : 'right';

      const instance = new marquee(el, {
        delayBeforeStart: 0,
        direction,
        pauseOnHover: window.innerWidth > 1024,
        duplicated: false,
        recalcResize: true,
        startVisible: true,
        gap: 26,
        duration: duration * 1000,
        ...getOptions(el, i),
      });

      el.dataset.marqueeInit = 'true';
      marqueeInstances.set(el, { instance, originalsCount: originals.length, itemSelector });
    });
  };

  const destroy = () => {
    marqueeInstances.forEach(({ instance, originalsCount, itemSelector }, el) => {
      instance.destroy?.();
      el.dataset.marqueeInit = 'false';

      const all = Array.from(el.querySelectorAll(itemSelector));
      const toRemove = all.slice(originalsCount);
      toRemove.forEach((item) => item.remove());
    });
    marqueeInstances.clear();
  };

  const handleChange = () => {

    console.log(media.matches);

    if (media.matches) {
      console.log(media.matches);
      console.log('init marquee on resize');
      
      init();
    } else {
      console.log('destroy marquee on resize');
      destroy();
    }
  };

  handleChange();
  media.addEventListener('change', handleChange);
}

// initResponsiveMarquee({
//   containerSelector: '.gallery-wrap',
//   itemSelector: '.gallery-item',
//   cloneTimes: 2,
//   breakpoint: '(max-width: 1023px)',
//   getOptions: () => ({ direction: 'left', duration: 8000 })
// });




const marqueeComponents = document.querySelectorAll('[data-marquee]');

const setupMarquee = (marquee) => {
  const maxMedia = marquee.dataset.maxMedia;
  const media = maxMedia ? window.matchMedia(maxMedia) : null;

  const cloneCount = parseInt(marquee.dataset.clone || '0', 10);

  const init = () => {
    if (marquee.dataset.marqueeInit === 'true') return;

    let wrapper;

    if (maxMedia) {
      wrapper = document.createElement('div');
      wrapper.classList.add('marquee__content');

      if(marquee.classList.contains('auto-speed')) {
        wrapper.classList.add('auto-speed');
      }

      const originalChildren = Array.from(marquee.children);
      originalChildren.forEach(child => {
        wrapper.appendChild(child);
      });

      for (let i = 0; i < cloneCount; i++) {
        originalChildren.forEach(child => {
          const clone = child.cloneNode(true);
          clone.dataset.clone = 'true';
          wrapper.appendChild(clone);
        });
      }

      marquee.appendChild(wrapper);

      const duplicate = wrapper.cloneNode(true);
      duplicate.setAttribute('aria-hidden', true);
      marquee.appendChild(duplicate);

    } else {
      wrapper = marquee.querySelector('.marquee__content');
      if (!wrapper) return console.warn('Missing .marquee__content inside', marquee);

      const originals = Array.from(wrapper.children).filter(el => !el.dataset.clone);
      for (let i = 0; i < cloneCount; i++) {
        originals.forEach(child => {
          const clone = child.cloneNode(true);
          clone.dataset.clone = 'true';
          wrapper.appendChild(clone);
        });
      }

      const duplicate = wrapper.cloneNode(true);
      duplicate.setAttribute('aria-hidden', true);
      marquee.appendChild(duplicate);
    }

    const childrenCount = wrapper.childElementCount;
    if (wrapper.classList.contains('auto-speed')) {
      wrapper.style.animationDuration = `${childrenCount * 10}s`;
    }

    if (!marquee.classList.contains('marquee')) marquee.classList.add('marquee');
    marquee.classList.add('marquee-active');
    marquee.dataset.marqueeInit = 'true';
  };

  const destroy = () => {
    if (marquee.dataset.marqueeInit !== 'true') return;

    if (maxMedia) {
      const clones = marquee.querySelectorAll('[aria-hidden="true"]');
      clones.forEach(clone => clone.remove());

      const wrapper = marquee.querySelector('.marquee__content');
      if (wrapper) {
        const children = Array.from(wrapper.children);
        children.forEach(child => {
          if (!child.dataset.clone) marquee.appendChild(child);
        });
        wrapper.remove();
      }
    } else {
      const wrapper = marquee.querySelector('.marquee__content');
      if (wrapper) {
        const toRemove = Array.from(wrapper.children).filter(el => el.dataset.clone === 'true');
        toRemove.forEach(el => el.remove());
      }

      const clones = marquee.querySelectorAll('[aria-hidden="true"]');
      clones.forEach(clone => clone.remove());
    }

    marquee.classList.remove('marquee');
    marquee.classList.remove('marquee-active');
    marquee.dataset.marqueeInit = 'false';
  };

  const handleChange = () => {
    if (media) {
      if (media.matches) {
        init();
      } else {
        destroy();
      }
    } else {
      init();
    }
  };

  handleChange();
  if (media) media.addEventListener('change', handleChange);
};

marqueeComponents.forEach(setupMarquee);